import * as React from "react";
import { MdKeyboardBackspace } from "react-icons/md";
import intl from "react-intl-universal";
import { Link as RouterLink } from "react-router-dom";

import { GlobalError } from "components/GlobalError";
import { Link } from "components/Link";
import { routing } from "routing";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  goBack: {
    display: "block",
    color: "white",
  },
}));

export const PageNotFound = () => {
  const classes = useStyles();
  return (
    <GlobalError title={intl.get("PAGE_NOT_FOUND_TEXT")}>
      <Link
        to={routing.Urls.ROOT}
        target="_self"
        className={classes.goBack}
        component={RouterLink}
      >
        <MdKeyboardBackspace /> {intl.get("PAGE_NOT_FOUND_GO_BACK")}
      </Link>
    </GlobalError>
  );
};
